import { useState } from 'react'
import { useStore } from '../hooks/useStore'
import { Link2, Check } from 'lucide-react'

export default function ShareLink() {
  const [copied, setCopied] = useState(false)
  const [showTooltip, setShowTooltip] = useState(false)
  const syncToCloudNow = useStore(state => state.syncToCloudNow)

  const handleCopy = async () => {
    try {
      // 触发立即同步
      syncToCloudNow()

      const currentUrl = window.location.href
      await navigator.clipboard.writeText(currentUrl)
      setCopied(true)

      // 2秒后恢复图标
      setTimeout(() => {
        setCopied(false)
      }, 2000)
    } catch (err) {
      console.error('复制失败:', err)
      // 降级方案：显示提示让用户手动复制
      alert('请手动复制当前页面链接：\n' + window.location.href)
    }
  }

  return (
    <div className="fixed top-4 right-4 sm:top-6 sm:right-6 z-50">
      <div className="relative">
        {/* 主按钮 */}
        <button
          onClick={handleCopy}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          className="flex items-center gap-2 px-3 py-2 bg-white/90 dark:bg-gray-800/90
                     backdrop-blur-sm rounded-full shadow-md hover:shadow-lg
                     transition-all duration-200 hover:scale-105 active:scale-95
                     border border-gray-200 dark:border-gray-700"
          aria-label="复制专属链接"
        >
          {copied ? (
            <>
              <Check className="w-4 h-4 text-green-500" />
              <span className="text-sm text-green-500 font-medium hidden sm:inline">已复制</span>
              <span className="text-xs text-green-500 font-medium sm:hidden">OK</span>
            </>
          ) : (
            <>
              <Link2 className="w-4 h-4 text-gray-600 dark:text-gray-300" />
              <span className="text-sm text-gray-600 dark:text-gray-300 font-medium hidden sm:inline">
                保存链接
              </span>
            </>
          )}
        </button>

        {/* Tooltip 提示 */}
        {showTooltip && !copied && (
          <div className="absolute top-full right-0 mt-2 w-64
                          bg-gray-900 text-white text-xs rounded-lg
                          shadow-xl p-3 animate-fade-in">
            <div className="absolute -top-1 right-4 w-2 h-2 bg-gray-900 rotate-45"></div>
            <p className="leading-relaxed">
              💡 复制此链接可在手机/电脑等任何设备继续填写
            </p>
          </div>
        )}

        {/* 复制成功提示 */}
        {copied && (
          <div className="absolute top-full right-0 mt-2 w-64
                          bg-green-500 text-white text-xs rounded-lg
                          shadow-xl p-3 animate-fade-in">
            <div className="absolute -top-1 right-4 w-2 h-2 bg-green-500 rotate-45"></div>
            <p className="leading-relaxed">
              ✅ 链接已复制！粘贴到微信/邮箱，可在其他设备继续
            </p>
          </div>
        )}
      </div>
    </div>
  )
}
